export default "__VITE_ASSET__44812bf6__"